import { setSeenWord } from '../store/slices/AdvanceSlice';
import { setCharacter, setQuestion, setTtalk, TCharacter, TquestionINT, TtalkStateINT, TtalkStateINTOptions } from '../store/slices/gameObjectSlice';
import { GameNames } from '../store/slices/GameTypes';
import { store } from '../store/store';
import { RootState } from './../store/store';
import { Action } from './Actions/Action';
import { Helper } from './Actions/HelperFuncs';
import Game from './Game';
import Question from './Questions';



export type Properties<T> = {
    readonly [P in keyof T]?: T[P];
};


export default class Character<Properties> {
    public static characters: TCharacter[] = [];
    public static mockProperties: any = {};
    private _name: string = '';
    readonly propertiesBackup: Properties;
    constructor(readonly key: string, protected _properties: Properties, public color: string, public imgPath?: string) {
        this.propertiesBackup = JSON.parse(JSON.stringify(this.properties));
        Character.characters.push(this);

    }


    public get character(): TCharacter {
        const char = {
            color: this.color,
            name: this.name,
            imgpath: this.imgPath,
            key: this.key

        };
        return char;
    }
    setQuestion(_question: Question): Promise<any> {
        const character = this.character;
        let question = <TquestionINT>{ displayQuestion: true, options: _question.options, title: _question.title };
        const data = { question, text: _question.title.text, character, wait: true };
        return new Action(data, GameNames.QUESTION).run(
            function question(callback: () => void) {
                store.dispatch(setQuestion(data));
                callback();
            }
            , false);

    }
    // get name() {

    //     // return (store.getState() as RootState).gameObject.present.characters[this.key]?.name || (store.getState() as RootState).gameObject.present.characters[this.key]?.key;
    //     return this.name || this.key;

    // }
    // set name(value: string) {

    //     // const data: TCharacter & { shouldStop?: boolean; } = { key: this.key, name: value, shouldStop: true };
    //     // store.dispatch(setCharacter({ ...data }));
    //     this.name = value;
    // }
    get name() {

        // _name to fix a bug I created
        return ((store.getState() as RootState).gameObject.present.characters[this.key] as any)?._name || (store.getState() as RootState).gameObject.present.characters[this.key]?.name || (store.getState() as RootState).gameObject.present.characters[this.key]?.key;

    }
    set name(value: string) {

        this._name = value;
    }

    talk(text: string, CharacterOptions?: TtalkStateINTOptions): Promise<any> {
        const character = this.character;
        const data = { text, character, options: CharacterOptions } as TtalkStateINT;
        return new Action(data, GameNames.TALK).run(
            function talk(callback: () => void) {
                const { currentScene } = store.getState().gameObject.present;
                
                store.dispatch(setTtalk({ ...data }));
                if (!Game.isReplayRunning) {
                    store.dispatch(setSeenWord(currentScene + ' ' + data.character?.key + ' ' + data.text));
                }
                callback();
            }
        );
    }
    think(text: string, CharacterOptions?: TtalkStateINTOptions): Promise<any> {
        const character = this.character;
        // console.log("Character talk");

        const data = { text, character, options: { ...CharacterOptions, think: true } } as TtalkStateINT;
        return new Action(data, GameNames.TALK).run(
            function talk(callback: () => void) {
                const { currentScene } = store.getState().gameObject.present;
                store.dispatch(setTtalk({ ...data }));
                store.dispatch(setSeenWord(currentScene + ' ' + data.character?.key + ' ' + data.text));
                callback();
            }
        );
    }
    get properties(): Readonly<Properties> {
        if (!(store.getState() as RootState).gameObject?.present?.characters[this.key]) {
            return this._properties;
        }
        this._properties = Object.freeze((store.getState() as RootState).gameObject?.present?.characters[this.key].properties) as Properties;
        return Object.freeze({ ...this.propertiesBackup, ...this._properties }) as Properties;
    }

    set(func: (properties: Properties) => void): Promise<any> {
        if (func.toString().includes(`===`) && !func.toString().includes(`=== null`)) {
            // throw new Error(`func ${func} contains ===`);
        }
        const userUpdated = Helper.parseObject(this.properties);
        // const data: TCharacter = { key: this.key, name: this.name, properties: userUpdated };
        const self = this;
        return new Action({}, GameNames.CHARACTERS).run(
            async function params(callback) {
                func(userUpdated as Properties);
                store.dispatch(setCharacter({ ...self.character, properties: userUpdated, name: self._name || self.character.name }));
                callback();
            }
        );

    }

    static initCharacters() {
        this.characters.forEach(character => {
            // const data: TCharacter = { key: character.key, properties: JSON.parse(JSON.stringify(character.propertiesBackup)), name: character.name || character.key };
            character.name = character.key;
            store.dispatch(setCharacter({ key: character.key, color: character.color, name: character.key, properties: character.propertiesBackup }));

        });

    }


}